import classes from './Hamburger.module.scss';

const Hamburger = ({ className, onClick }) => {
  const containerClasses = [classes.container];
  if (className) {
    containerClasses.push(className);
  }

  return (
    <div className={containerClasses.join(' ')} onClick={onClick}>
      <div className={classes.part}></div>
      <div className={classes.part}></div>
      <div className={classes.part}></div>
    </div>
  );
};

export default Hamburger;
